import { BigNumber } from '@0x/utils';
import React from 'react';
import styled from 'styled-components';
import { fixBigNumber } from '../../util/number_utils';
import { tokenAmountInUnits, unitsInTokenAmount } from '../../util/tokens';
// import {MAX_LENGTH } from '../../common/constants';

const I18n = require('i18n-js');

interface Props {
    autofocus?: boolean;
    className?: string;
    decimals: number;
    placeholder?: string;
    max?: BigNumber;
    min?: BigNumber;
    onChange: (newValue: BigNumber) => void;
    step?: BigNumber;
    value: BigNumber | null;
    valueFixedDecimals?: number;
    pair?: string;
}

interface State {
    currentValueStr: string;
}

const Input = styled.input`
    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -moz-appearance: textfield;
`;
const KEYS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz/?;:\':\"~!@#$%^&*()_+-=[{]}\\|`<>,';

export class BigNumberInput extends React.Component<Props, State> {
    public static defaultProps = {
        placeholder: '0.00',
    };

    public readonly state = {
        currentValueStr: this.props.value
            ? (tokenAmountInUnits(this.props.value, this.props.decimals, this.props.valueFixedDecimals))
            : '',
    };

    private _textInput: any;

    public static getDerivedStateFromProps = (props: Props, state: State) => {
        const { decimals, value, valueFixedDecimals } = props;
        const { currentValueStr } = state;
        if (!value) {
            return {
                currentValueStr: '',
            };
        }
        else if (value && value.toString().indexOf('e') > -1) {
            return {
                currentValueStr: fixBigNumber(value),
            };
        }
        else if (value && !unitsInTokenAmount(currentValueStr || '0', decimals).eq(value)) {
            let v = tokenAmountInUnits(value, decimals, valueFixedDecimals);
            if (v && v.toString().indexOf('e') > -1) {
                v = fixBigNumber(value);
            }
            return {
                currentValueStr: v,
            };
        } else {
            return null;
        }
    };

    public componentDidMount = () => {
        const { autofocus } = this.props;

        if (autofocus) {
            this._textInput.focus();
        }
    };

    public render = () => {
        const { currentValueStr } = this.state;
        const { decimals, step, min, max, className, placeholder, pair } = this.props;
        const stepStr = step && tokenAmountInUnits(step, decimals);
        const minStr = min && tokenAmountInUnits(min, decimals);
        const maxStr = max && tokenAmountInUnits(max, decimals);
        let _currentValueStr = currentValueStr ? fixBigNumber(currentValueStr) : '';
        const isWwxUsdt = pair === 'wwxusdt' || pair === 'usdtwwx' ? true : false;
        if (isWwxUsdt) {
            const v = new BigNumber(currentValueStr);
            _currentValueStr = v.integerValue().toString();
        }
        return (
            <Input
                className={className}
                max={maxStr}
                min={minStr}
                onChange={this._updateValue}
                ref={_ref => (this._textInput = _ref)}
                step={stepStr}
                type={'number'}
                value={_currentValueStr}
                placeholder={placeholder}
                data-original-title={I18n.t('pleaseEnterNumber')}
                title={I18n.t('pleaseEnterNumber')}
                onKeyDown={(e) => {
                    if (isWwxUsdt && e.key === '.') return e.preventDefault();
                    if (KEYS.indexOf(e.key) > -1) e.preventDefault()
                }}
            />
        );
    };

    private readonly _updateValue: React.ReactEventHandler<HTMLInputElement> = e => {
        const { decimals, onChange, min, max } = this.props;
        const newValueStr = e.currentTarget.value;

        const newValue = unitsInTokenAmount(newValueStr || '0', decimals);
        const invalidValue = (min && newValue.isLessThan(min)) || (max && newValue.isGreaterThan(max));
        if (invalidValue) {
            return;
        }

        onChange(newValue);

        this.setState({
            currentValueStr: newValueStr,
        });
    };
}
